import { useShopStore } from '../../../hooks/useShopStore';
import { useEventStore } from '../../../hooks/useEventStore';
import { usePrefectureArtists } from '../../../hooks/usePrefectureArtists';
import { artistsData } from '../../../mocks/artists';

export function PrefectureHeader() {
  const { shops } = useShopStore();
  const { events } = useEventStore();
  const { count: dbArtistCount, loading } = usePrefectureArtists('nara');
  const mockArtistCount = artistsData.filter((a) => a.prefecture === 'nara').length;
  const totalArtistCount = dbArtistCount + mockArtistCount;

  return (
    <div className="relative overflow-hidden">
      {/* Background grid */}
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage:
            'linear-gradient(#333 1px, transparent 1px), linear-gradient(90deg, #333 1px, transparent 1px)',
          backgroundSize: '40px 40px',
        }}
      />

      {/* Glow accents */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-neon-green/5 blur-[100px] rounded-full" />
      <div className="absolute bottom-0 left-1/4 w-48 h-48 bg-neon-pink/5 blur-[80px] rounded-full" />

      <div className="relative z-10 container mx-auto px-4 sm:px-8 pt-20 lg:pt-24 pb-8 lg:pb-12">
        {/* Breadcrumb */}
        <div className="flex items-center gap-2 text-xs text-gray-600 mb-4 lg:mb-6">
          <a href="/" className="hover:text-white transition-colors cursor-pointer">HOME</a>
          <span>/</span>
          <a href="/directory" className="hover:text-white transition-colors cursor-pointer">DIRECTORY</a>
          <span>/</span>
          <span className="text-neon-green">NARA</span>
        </div>

        {/* Title area */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4 lg:gap-8">
          <div>
            <div className="flex items-center gap-3 mb-2">
              <div className="w-2 h-2 rounded-full bg-neon-green" style={{ boxShadow: '0 0 10px #00ff41' }} />
              <span className="text-gray-500 text-[10px] tracking-[0.3em] uppercase">Prefecture Directory</span>
            </div>
            <div className="flex items-baseline gap-4 mb-2">
              <h1 className="font-display text-5xl sm:text-6xl lg:text-8xl text-white tracking-wider">
                NARA
              </h1>
              <span className="text-gray-400 text-lg lg:text-2xl font-light">奈良県</span>
            </div>
            <div
              className="w-20 h-1 bg-neon-green mb-4"
              style={{ boxShadow: '0 0 15px #00ff41' }}
            />
            <p className="text-gray-400 text-sm lg:text-base leading-relaxed max-w-lg">
              古都の静寂の中に息づく<strong className="text-white">アンダーグラウンドシーン</strong>。
              奈良県内の音楽スポットを探索しよう。
            </p>
          </div>

          {/* Stats */}
          <div className="flex gap-6 lg:gap-8">
            <a
              href="#shop-list"
              className="text-center cursor-pointer group"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('shop-list')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              <div className="text-neon-green text-2xl lg:text-3xl font-bold group-hover:scale-110 transition-transform duration-300">{shops.length}</div>
              <div className="text-gray-500 text-[10px] lg:text-xs tracking-wider group-hover:text-neon-green transition-colors duration-300">SHOPS</div>
            </a>
            <a
              href="#artist-list"
              className="text-center cursor-pointer group"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('artist-list')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              <div className="text-neon-pink text-2xl lg:text-3xl font-bold group-hover:scale-110 transition-transform duration-300">
                {loading ? '...' : totalArtistCount}
              </div>
              <div className="text-gray-500 text-[10px] lg:text-xs tracking-wider group-hover:text-neon-pink transition-colors duration-300">ARTISTS</div>
            </a>
            <a
              href="#event-list"
              className="text-center cursor-pointer group"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('event-list')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              <div className="text-neon-blue text-2xl lg:text-3xl font-bold group-hover:scale-110 transition-transform duration-300">{events.length}</div>
              <div className="text-gray-500 text-[10px] lg:text-xs tracking-wider group-hover:text-neon-blue transition-colors duration-300">EVENTS</div>
            </a>
          </div>
        </div>
      </div>

      {/* Bottom border */}
      <div className="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
    </div>
  );
}
